import { QuestionTypeChip } from '@exam-management/components';
import { QuestionGroupType } from '@exam-management/graphql';
import {
  Chip,
  CopyToClipboard,
  ContentPreviewer,
  Divider,
  Flex,
  Text,
  ReadonlyField,
} from '@shared/components';
import { useMemo } from 'react';

import { QuestionChoiceList } from '../../components';

export interface QuestionDetailsProps {
  refCode: string;
  difficulty?: string;
  calculation?: string;
  type?: string;
  details?: string;
  correctAnswer?: string;
  reference?: string;
  solution?: string;
  los?: string;
  choices: {
    value: string;
    label: string;
    order: number;
  }[];
  size?: number;
}

export default function QuestionDetails(props: Readonly<QuestionDetailsProps>) {
  const {
    refCode,
    difficulty = '-',
    calculation = '-',
    type = '',
    details = '-',
    choices,
    correctAnswer = '-',
    reference = '-',
    solution = '-',
    los = '-',
    size,
  } = props;

  const qType = useMemo(() => {
    switch (type) {
      case QuestionGroupType.Single:
      case QuestionGroupType.LotOfQuestion:
        return 'single';
      case QuestionGroupType.ItemSet:
        return 'item-set';
      default:
        throw new Error('Invalid question type');
    }
  }, [type]);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
      <Flex sx={(theme) => ({ gap: theme.spacing(4), alignItems: 'center' })}>
        <Text variant='h5' sx={{ flexGrow: 1 }}>
          คำถาม
        </Text>
        <Text>
          ระดับความยาก: {difficulty}, {calculation}
        </Text>
        <Divider orientation='vertical' flexItem />
        <Text>QType:</Text>
        <QuestionTypeChip type={qType} questionSize={size} />
        <Divider orientation='vertical' flexItem />
        <CopyToClipboard
          text={refCode}
          as={Chip}
          label={<Text variant='body2Semibold'>{refCode}</Text>}
        />
      </Flex>
      <ReadonlyField content={<ContentPreviewer content={details} />} />
      <QuestionChoiceList choices={choices} value={correctAnswer} />
      <Divider />
      <ReadonlyField label='คำอธิบายเฉลย' content={<ContentPreviewer content={solution} />} />
      <ReadonlyField label='หนังสืออ้างอิง' content={<ContentPreviewer content={reference} />} />
      <ReadonlyField label='วัตถุประสงค์การเรียนรู้ (LOS)' content={los} />
    </Flex>
  );
}
